import React from 'react'

const NameCol = ({ name }) => {
    return (
        <p className='main_mobile_header_table_row_name_p' >{name}</p>
    )
}

export default NameCol